import React from 'react';

function FriendsPage() {
  return(
    <div>
      <h1>FriendsPage</h1>
    </div>
  );
}

export default FriendsPage;